export const footer = {
  "description": "Het woningruilplatform tussen Airbnb-eigenaars. Reis gratis overal ter wereld.",
  "company": "Bedrijf",
  "about": "Over ons",
  "howItWorks": "Hoe het werkt",
  "blog": "Blog",
  "careers": "Carrières",
  "support": "Ondersteuning",
  "help": "Helpcentrum",
  "contact": "Contact",
  "terms": "Gebruiksvoorwaarden",
  "privacy": "Privacybeleid",
  "community": "Gemeenschap",
  "members": "Leden",
  "destinations": "Bestemmingen",
  "events": "Evenementen",
  "newsletter": "Nieuwsbrief",
  "newsletterText": "Ontvang onze laatste aanbiedingen en nieuws",
  "emailPlaceholder": "Uw e-mail",
  "newsletterSuccess": "Inschrijving geslaagd!",
  "newsletterError": "Er is een fout opgetreden.",
  "newsletterInvalid": "Ongeldig e-mailadres.",
  "subscribe": "Abonneren",
  "rights": "Alle rechten voorbehouden",
  "madeWith": "Gemaakt met",
  "by": "door het TRAVELTROK-team"
};
